<template>
	<div class="new-folder">
        <input type="text" placeholder="Name" v-model="name" class="form-control">
        <button class="btn btn-sm btn-primary" @click="CreateFolder" :disabled="name == ''">Create</button>
	</div>
</template>

<script>
	export default {
		props: { parentId: Number },

		data(){
            return {
                'name': ''
            }
        },

        methods: {
            CreateFolder(){
                let self = this;
                this.$store.dispatch('createFolder', {
                    parent_id: this.parentId,
                    name: this.name,
                    parent: this.$parent.closeModal
                });
            }
        }
	}
</script>
